import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { Link } from 'react-router-dom'
import { Star, Bullseye, Shield, CheckCircle, ChevronLeft, ChevronRight } from 'react-bootstrap-icons'
import BannerImg from '../assets/images/awards/Banner.jpg'
import BannerMobile from '../assets/images/awards/BannerMobile.jpg'
import Img1 from '../assets/images/awards/Img1.webp'
import Img2 from '../assets/images/awards/Img2.png'
import Img3 from '../assets/images/awards/Img3.png'
import Img4 from '../assets/images/awards/Img4.png'
import Img5 from '../assets/images/awards/Img5.png'

const AwardsAndAchievements = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const awards = [
        {
            id: 1,
            title: 'Binghatti Award',
            category: 'Sales Excellence',
            year: '2025',
            image: Img1,
        },
        {
            id: 2,
            title: 'Shahrukhz by Danube Competition',
            category: 'Sales Excellence',
            year: '2025',
            image: Img2,
        },
        {
            id: 3,
            title: '1% Elite Broker Award by Danube',
            category: 'Elite Recognition',
            year: '2025',
            image: Img3,
        },
        {
            id: 4,
            title: 'Gulf Achievers Award 2025',
            category: 'Regional Excellence',
            year: '2025',
            image: Img4,
        },

        {
            id: 5,
            title: 'The Asian Arab Business Awards 2025',
            category: 'Excellence & Innovation',
            year: '2025',
            image: Img5,
        },
    ]

    const [currentSlide, setCurrentSlide] = useState(0)
    const [awardsPerSlide, setAwardsPerSlide] = useState(3)
    const totalSlides = awards.length - awardsPerSlide + 1

    useEffect(() => {
        const handleResize = () => {
            setAwardsPerSlide(window.innerWidth >= 768 ? 3 : 1)
        }

        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        setCurrentSlide(0)
    }, [awardsPerSlide])

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides)
    }

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides)
    }

    const goToSlide = (index) => {
        setCurrentSlide(index)
    }

    const achievements = [
        {
            title: 'Years of Excellence',
            value: '15+',
            description: 'Dedicated service in Dubai real estate market',
        },
        {
            title: 'Properties Sold',
            value: '5000+',
            description: 'Successful transactions across Dubai',
        },
        {
            title: 'Happy Clients',
            value: '3000+',
            description: 'Satisfied customers worldwide',
        },
        {
            title: 'Industry Awards',
            value: '25+',
            description: 'Recognitions for excellence',
        },
    ]

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Awards & Achievements | 800 Homes - Dubai Real Estate Excellence</title>
                <meta
                    name="description"
                    content="Discover 800 Homes' prestigious awards and achievements in Dubai real estate. Recognized for excellence, innovation, and trusted service by industry leaders."
                />
                <link rel="canonical" href="https://800homes.ae/awards-and-achievements/" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="Awards & Achievements | 800 Homes - Dubai Real Estate Excellence" />
                <meta
                    property="og:description"
                    content="Discover 800 Homes' prestigious awards and achievements in Dubai real estate. Recognized for excellence, innovation, and trusted service by industry leaders."
                />
                <meta property="og:url" content="https://md.eacademe.org/awards-and-achievements" />
                <meta property="og:site_name" content="800 Homes" />
                <meta property="og:image" content="https://md.eacademe.org/images/awards/awards-banner.webp" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta
                    property="og:image:secure_url"
                    content="https://md.eacademe.org/images/awards/awards-banner.webp"
                />
                <meta property="og:image:type" content="image/webp" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Awards & Achievements | 800 Homes - Dubai Real Estate Excellence" />
                <meta
                    name="twitter:description"
                    content="Discover 800 Homes' prestigious awards and achievements in Dubai real estate. Recognized for excellence, innovation, and trusted service by industry leaders."
                />
                <meta name="twitter:image" content="https://md.eacademe.org/images/awards/awards-banner.webp" />
            </Helmet>

            <section id="website-responsive" className="container-fluid px-0">
                <section className="d-none d-md-block">
                    <section
                        className="container-fluid bg-common-banner bg-home vh-100 px-0"
                        style={{ backgroundImage: `url(${BannerImg})` }}
                    >
                        <Header />
                        <div className="py-md-5 mt-md-3 mt-5" />
                        <div className="col-10 mx-auto ps-md-3">
                            <h1
                                className="fw-500 text-white fs-home-banner text-uppercase lh-sm"
                                style={{ transform: 'scale(0.93)', transformOrigin: 'left' }}
                            >
                                Award-Winning <br /> Excellence in Dubai <br />
                                Real Estate
                            </h1>
                            <h2 className="text-white fs-sub-home-banner fw-400" style={{ lineHeight: '1.5' }}>
                                Trusted by investors, homeowners, <br /> and developers for results that matter.
                            </h2>
                        </div>
                    </section>
                </section>

                <section className="d-block d-md-none">
                    <section
                        className="container-fluid bg-common-banner bg-home vh-100 px-0"
                        style={{ backgroundImage: `url(${BannerMobile})` }}
                    >
                        <Header />
                        <div className="py-md-5 mt-md-3 mt-5" />
                        <div className="col-10 mx-auto ps-md-3">
                            <h1
                                className="fw-500 text-white fs-home-banner text-uppercase lh-sm"
                                style={{ transform: 'scale(0.93)', transformOrigin: 'left' }}
                            >
                                Award-Winning <br /> Excellence in Dubai <br />
                                Real Estate
                            </h1>
                            <h2
                                className="text-white fs-sub-home-banner fw-400"
                                style={{ lineHeight: '1.5', transform: 'scale(1.2)', transformOrigin: 'left' }}
                            >
                                Trusted by investors, homeowners, <br /> and developers for results that matter.
                            </h2>
                        </div>
                    </section>
                </section>

                <section className="py-md-5 py-4" />

                {/* Introduction Section */}
                <section className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-8 text-center">
                            <div className="text-ss-primary fs-ss-18 fw-400 pb-3">Our Commitment to Clients</div>
                            <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">
                                Recognized as Industry Leaders
                            </h2>
                            <p className="text-grey fs-ss-18 fw-300 lh-1-7em">
                                At 800 Homes, excellence isn’t claimed — it’s earned. Our industry recognition reflects
                                a relentless focus on performance, integrity, and meaningful results for our clients.
                                Each award represents the trust placed in us by investors, homeowners, and developers
                                navigating Dubai’s fast-moving property market.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Awards Carousel */}
                <section className="container-fluid">
                    <div className="text-center">
                        <div className="text-ss-primary fs-ss-18 fw-400">Recent Recognition</div>
                        <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">Prestigious Awards</h2>
                    </div>

                    <div className="position-relative px-4 col-md-10 mx-auto px-md-5">
                        <div className="overflow-hidden">
                            <div
                                className="d-flex transition-transform"
                                style={{
                                    transform: `translateX(-${currentSlide * (100 / awardsPerSlide)}%)`,
                                    transition: 'transform 0.5s ease-in-out',
                                    gap: awardsPerSlide === 3 ? '1.5rem' : '0',
                                    paddingRight: awardsPerSlide === 3 ? '1.5rem' : '0',
                                }}
                            >
                                {awards.map((award, index) => (
                                    <div
                                        key={award.id}
                                        className="flex-shrink-0"
                                        style={{ width: awardsPerSlide === 3 ? 'calc(33.33% - 1rem)' : '100%' }}
                                    >
                                        <div className="border-white border-1 border h-100 d-flex flex-column">
                                            <div className="text-center">
                                                <div className="pb-3">
                                                    <img
                                                        src={award.image}
                                                        alt={award.title}
                                                        className="w-100"
                                                        onError={(e) => {
                                                            e.target.src =
                                                                'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Award+Image'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="p-4 flex-grow-1 d-flex flex-column">
                                                <h3 className="text-white fs-ss-22 fw-600 text-center mb-3">
                                                    {award.title}
                                                </h3>
                                                <div className="mt-auto">
                                                    {award.category && award.year && (
                                                        <div className="text-center">
                                                            <span className="badge bg-ss-primary text-white fs-ss-14 fw-400">
                                                                {award.category}
                                                            </span>
                                                            <span className="ms-2 badge bg-secondary text-white fs-ss-14 fw-400">
                                                                {award.year}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Navigation Buttons */}
                        {totalSlides > 1 && (
                            <>
                                <button
                                    onClick={prevSlide}
                                    className="position-absolute top-50 translate-middle-y btn btn-outline-light d-none d-md-block"
                                    style={{ zIndex: 10, left: '-4rem' }}
                                >
                                    <ChevronLeft size={24} />
                                </button>
                                <button
                                    onClick={nextSlide}
                                    className="position-absolute top-50 translate-middle-y btn btn-outline-light d-none d-md-block"
                                    style={{ zIndex: 10, right: '-4rem' }}
                                >
                                    <ChevronRight size={24} />
                                </button>
                            </>
                        )}

                        {/* Dots Indicator */}
                        {totalSlides > 1 && (
                            <div className="text-center mt-4">
                                {Array.from({ length: totalSlides }).map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => goToSlide(index)}
                                        className={`mx-1 border-0 ${
                                            currentSlide === index ? 'bg-ss-primary' : 'bg-secondary'
                                        }`}
                                        style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            padding: 0,
                                            cursor: 'pointer',
                                        }}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Achievement Stats */}
                <section className="container-fluid bg-dark py-5">
                    <div className="text-center">
                        <div className="text-ss-primary fs-ss-18 fw-400 pb-4">Our Impact</div>
                        <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">Achievements That Speak</h2>
                    </div>

                    <div className="row justify-content-center text-center px-md-5 gy-4">
                        {achievements.map((achievement, index) => (
                            <div key={index} className="col-md-3 col-6">
                                <div
                                    className={`border-white border-end border-1 h-100 d-flex flex-column justify-content-center d-none d-md-block ${index === achievements.length - 1 ? 'border-end-0' : ''}`}
                                >
                                    <div className="fs-ss-40 text-ss-primary fw-600">{achievement.value}</div>
                                    <div className="fs-ss-18 text-white fw-500">{achievement.title}</div>
                                    <div className="fs-ss-14 text-grey fw-300 mt-2">{achievement.description}</div>
                                </div>
                                <div className="h-100 d-flex flex-column justify-content-center d-block d-md-none">
                                    <div className="fs-ss-40 text-ss-primary fw-600">{achievement.value}</div>
                                    <div className="fs-ss-18 text-white fw-500">{achievement.title}</div>
                                    <div className="fs-ss-14 text-grey fw-300 mt-2">{achievement.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
                {/* CTA Section */}
                <section className="container-fluid bg-middle-banner py-5">
                    <div className="row justify-content-center py-md-5">
                        <div className="col-11 col-md-9 mx-auto text-center">
                            <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-600">
                                Experience Award-Winning Service
                            </h2>
                            <p className="pb-md-4 pb-3 text-white fs-ss-22 fw-300 lh-1-7em">
                                Join thousands of satisfied clients who have experienced our award-winning real estate
                                services. Let our expertise guide you to your dream property in Dubai.
                            </p>
                            <div className="text-white fs-ss-18 fw-400">
                                <Link
                                    to="/contact-us"
                                    className="text-decoration-none px-4 py-ss-2 text-white bg-ss-primary bg-hover-ss-primary rounded-5"
                                >
                                    Get in Touch
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />

                {/* Values Section */}
                <section className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-8 text-center">
                            <div className="text-ss-primary fs-ss-18 fw-400 pb-3">Our Values</div>
                            <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">
                                Standards That Guide Every Transaction
                            </h2>
                            <p className="text-grey fs-ss-18 fw-300 lh-1-7em mb-5">
                                Our recognition reflects more than results — it represents the principles we uphold and
                                the responsibility we carry in every client relationship.
                            </p>
                        </div>
                    </div>

                    <div className="row justify-content-center gy-4 px-4 px-md-5">
                        <div className="col-11 col-md-6 col-lg-3">
                            <div className="text-center">
                                <CheckCircle className="text-ss-primary mb-3" size={40} />
                                <h4 className="text-white fs-ss-20 fw-600 mb-3">Integrity</h4>
                                <p className="text-grey fs-ss-16 fw-300 lh-1-6em">
                                    Transparent and honest dealings in every transaction
                                </p>
                            </div>
                        </div>
                        <div className="col-11 col-md-6 col-lg-3">
                            <div className="text-center">
                                <Star className="text-ss-primary mb-3" size={40} />
                                <h4 className="text-white fs-ss-20 fw-600 mb-3">Excellence</h4>
                                <p className="text-grey fs-ss-16 fw-300 lh-1-6em">
                                    Consistently delivering exceptional service and results
                                </p>
                            </div>
                        </div>
                        <div className="col-11 col-md-6 col-lg-3">
                            <div className="text-center">
                                <Bullseye className="text-ss-primary mb-3" size={40} />
                                <h4 className="text-white fs-ss-20 fw-600 mb-3">Innovation</h4>
                                <p className="text-grey fs-ss-16 fw-300 lh-1-6em">
                                    Embracing new technologies and approaches in real estate
                                </p>
                            </div>
                        </div>
                        <div className="col-11 col-md-6 col-lg-3">
                            <div className="text-center">
                                <Shield className="text-ss-primary mb-3" size={40} />
                                <h4 className="text-white fs-ss-20 fw-600 mb-3">Trust</h4>
                                <p className="text-grey fs-ss-16 fw-300 lh-1-6em">
                                    Building lasting relationships through reliability
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-md-5 py-4" />
                <Footer />
            </section>
        </>
    )
}

export default AwardsAndAchievements
